import { PageContainer } from '../../../shared/PageContainer';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { PageDefaultSegment, useFeedback } from "@sis/react-library";
import { useState } from 'react';
import { FormSamplesOutput } from '../FormSamplesOutput';
import { callMimicApi } from '../../../../utils/commonUtils';
import { Box, Typography } from '@mui/material';
import { FormSamplesNonFieldtemsExample1Form } from './FormSamplesNonFieldtemsExample1Form';
import { FormSamplesNonFieldtemsExample2Form } from './FormSamplesNonFieldtemsExample2Form';

/////////////////////////////////////////////////////////////////////////////////////////////
// Existing interface (would be defined elsewhere in the project).
/////////////////////////////////////////////////////////////////////////////////////////////
export interface Example1Dto {
  question: string;
  answer: string;
}

export interface Example2Dto {
  id?: number;
  firstName: string;
  lastName: string;
}

export const FormSamplesNonFieldtemsPage = () => {

  const [submittedValuesExample1, setSubmittedValuesExample1] = useState<Example1Dto | undefined>(undefined)
  const [submittedValuesExample2, setSubmittedValuesExample2] = useState<object | undefined>(undefined)
  const [submitting, setSubmitting] = useState(false);
  const { showError } = useFeedback();

  const handleSubmitExample1 = async (values: Example1Dto) => {
    setSubmitting(true);
    setSubmittedValuesExample2(undefined);  // Reset example 2 so json submit doesn't show
    setSubmittedValuesExample1(values);

    try {
      // In the api call, uncomment the exception in there to test errors coming from the api
      await callMimicApi();
    } catch (ex) {
      showError(`An error occured: ${ex}`);
      return false;
    } finally {
      setSubmitting(false);
    }
  }

  const handleSubmitExample2 = async (values: Example2Dto, profilePictureFile: File | undefined) => {
    setSubmitting(true);
    setSubmittedValuesExample1(undefined);  // Reset example 2 so json submit doesn't show
    setSubmittedValuesExample2({ submitValuesFromForm: values, seperateProfilePicFile: profilePictureFile });

    try {
      // In the api call, uncomment the exception in there to test errors coming from the api
      await callMimicApi();
    } catch (ex) {
      showError(`An error occured: ${ex}`);
      return false;
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <PageContainer heading='Form Samples - Non Field Items' icon={<TextSnippetIcon />}          >
      <PageDefaultSegment width={400}>
        <Typography variant="h6">Example 1</Typography>
        <FormSamplesNonFieldtemsExample1Form
          submitting={submitting}
          onSubmit={handleSubmitExample1}
        />
      </PageDefaultSegment>
      <FormSamplesOutput width={400} submittedValues={submittedValuesExample1} />
      <Box sx={{ marginTop: 4 }}>
        <PageDefaultSegment width={400}>
          <Typography variant="h6">Example 2</Typography>
          <FormSamplesNonFieldtemsExample2Form
            submitting={submitting}
            onSubmit={handleSubmitExample2}
          />
        </PageDefaultSegment>
        <FormSamplesOutput width={400} submittedValues={submittedValuesExample2} />
      </Box>
    </PageContainer>
  )
}
